<template>
  <div
    class="table-page"
    :class="{
      'layout-mode-dialog': layoutMode === 'dialog',
      'layout-mode-page': layoutMode === 'page',
      'layout-mode-tab': layoutMode === 'tab',
      'show-summary': showSummary,
    }"
  >
    <div class="search-bar" v-if="$slots.search">
      <slot name="search" />
    </div>
    <div class="table-header" v-if="$slots['table-header']">
      <slot name="table-header" />
    </div>
    <div class="table-content" :class="{ 'table-content-summary': showSummary }">
      <slot name="table-content" :tableProps="tableProps" />
    </div>
    <div class="table-pagination" v-if="$slots.pagination">
      <slot name="pagination" />
    </div>
    <!-- <div class="table-content-summary"></div> -->
  </div>
</template>
<script>
import { ref } from 'vue'
export default {
  name: 'TablePage',
  props: {
    layoutMode: {
      type: String,
      default: 'page', //dialog,page
    },
    showSummary: {
      type: Boolean,
      default: false,
    },
    summaryMethod: {
      type: Function,
      default: undefined,
    },
  },
  setup(props) {
    const tableProps = ref({
      border: true,
      stripe: true,
      size: 'mini',
      height: '100%',
      highlightCurrentRow: true,
      summaryMethod: props.summaryMethod,
      showSummary: props.showSummary,
    })
    return {
      tableProps,
    }
  },
}
</script>
<style lang="scss" scoped>
.table-page {
  padding: 12px;
  box-sizing: border-box;
  width: 100%;
  background: #f5f5f5;
  flex-direction: column;
  display: flex;
  overflow: hidden;
  &.layout-mode-dialog {
    ::v-deep .el-table {
      max-height: 600px !important;
    }
  }

  &.layout-mode-dialog,
  &.layout-mode-tab {
    background: #fff;
    .search-bar {
      padding: 0px;
      padding-bottom: 0;
      margin-bottom: 0px;
    }

    .table-header {
      margin-bottom: 8px;
    }

    .table-content {
      padding: 0px;
      padding-bottom: 0;
    }

    .table-pagination {
      background: #fff !important;
      // padding: 0 12px;
    }
  }
  &.layout-mode-tab {
    height: calc(100vh - 174px);
    background: #fff;
    padding: 0 12px;
    .search-bar {
      padding-bottom: 20px;
    }
    .table-header {
      margin-bottom: 12px;
    }
    .table-content {
      padding-top: 0px;
    }
  }
  &.layout-mode-dialog {
    height: 100%; //520px;
    padding: 0px;
    .table-content {
      padding-top: 4px;
    }
  }
  &.layout-mode-page {
    height: calc(100vh - 96px);
  }

  .search-bar {
    background: #fff;
    padding: 12px;
    padding-bottom: 0;
    margin-bottom: 12px;
    // 预留：可在这里调整搜索项的边距
  }

  .table-header {
    margin-bottom: 12px;
  }
  .table-content {
    flex: 1;
    background: #fff;
    padding: 12px;
    padding-bottom: 0;
    display: flex;
    overflow: hidden;
    flex-direction: column;
    &.table-content-summary {
      ::v-deep .el-table {
        overflow: auto;
        .el-table__body-wrapper {
          height: calc(100% - 72px) !important;
        }
      }
    }
    ::v-deep .el-table .el-table__header-wrapper {
      thead th {
        background: #f5f5f5;
        color: #555;
        font-weight: bold;
        text-align: center;
      }
    }
    ::v-deep .el-table__fixed-right .el-table__fixed-header-wrapper {
      thead th {
        background: #f5f5f5;
        color: #555;
        font-weight: bold;
        text-align: center;
      }
    }
    ::v-deep .el-table__fixed .el-table__fixed-header-wrapper {
      thead th {
        background: #f5f5f5;
        color: #555;
        font-weight: bold;
        text-align: center;
      }
    }
  }
  .table-content-summary {
    height: 40px;
    background: #fff;
  }
  .table-pagination {
    background: #fff !important;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    // margin-top: -40px;
    height: 40px;
    ::v-deep .pagination-container {
      margin-top: 0;
    }
  }
}
</style>
